import { myFetch, HttpMethod } from "./baseService";

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface EstatusRespuestaPreguntaAsamblea {
  erp_codigo: string;
  erp_nombre: string;
}

export const obtenerEstatusRespuestaPreguntaAsamblea = async () => {
  const envelope = await myFetch<ApiEnvelope<EstatusRespuestaPreguntaAsamblea[]>>(
    "estatus_respuesta_pregunta_asamblea/ObtenerTodos",
    HttpMethod.POST,
    {}
  );

  return envelope;
};
